import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Save, Loader2 } from "lucide-react";

const field = "w-full border border-[#E5E5E5] bg-white px-4 py-2.5 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-restrained-blue";
const FIELDS = [
  { k: "company_name", label: "Company name" },
  { k: "legal_name", label: "Legal entity name (footer)" },
  { k: "tagline", label: "Tagline" },
  { k: "description", label: "Description", textarea: true },
  { k: "email", label: "Contact email (leave blank if unverified)" },
  { k: "phone", label: "Contact phone (leave blank if unverified)" },
  { k: "address", label: "HQ address (leave blank if unverified)" },
  { k: "linkedin", label: "LinkedIn URL" },
  { k: "seo_title", label: "Default SEO title" },
  { k: "seo_description", label: "Default SEO description", textarea: true },
];

export default function SettingsAdmin() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then(({ data }) => setS(data)).catch(() => setS({}));
  }, []);

  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/admin/settings", s); setS(data); toast.success("Settings saved"); }
    catch { toast.error("Save failed"); }
    setSaving(false);
  };

  if (!s) return <div className="py-32 flex justify-center"><Loader2 className="animate-spin text-restrained-blue" /></div>;

  return (
    <div className="max-w-3xl">
      <div className="flex items-center justify-between mb-8">
        <div><h1 className="font-serif text-4xl text-deep-navy">Corporate details</h1><p className="text-charcoal/60">Unverified fields left blank stay hidden from the public site.</p></div>
        <button onClick={save} disabled={saving} data-testid="settings-save" className="inline-flex items-center gap-2 bg-deep-navy text-white px-5 py-2.5 text-sm hover:bg-restrained-blue transition-colors">{saving ? <Loader2 size={15} className="animate-spin" /> : <Save size={15} />} Save</button>
      </div>
      <div className="bg-white border border-[#E5E5E5] p-6 md:p-8 space-y-5">
        {FIELDS.map((f) => (
          <div key={f.k}>
            <label className="overline text-charcoal/60 block mb-2">{f.label}</label>
            {f.textarea
              ? <textarea rows={3} className={`${field} resize-none`} value={s[f.k] || ""} onChange={(e) => setS((p) => ({ ...p, [f.k]: e.target.value }))} data-testid={`settings-${f.k}`} />
              : <input className={field} value={s[f.k] || ""} onChange={(e) => setS((p) => ({ ...p, [f.k]: e.target.value }))} data-testid={`settings-${f.k}`} />}
          </div>
        ))}
      </div>
    </div>
  );
}
